// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__AC7Us","inner":"Form_inner__2ua59","range":"Form_range__il_w8","name":"Form_name__2Fb0I","actions":"Form_actions__3VGXV"};